import React, { useState, useEffect } from "react";
import { Box, Typography, Button, Card, CardActions } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import WarningIcon from "@mui/icons-material/Warning";
import { red, green, yellow, orange } from "@mui/material/colors";
import { useNavigate } from "react-router-dom";

const route = process.env.REACT_APP_URL_BACKEND;

const getStatusColor = (status) => {
  if (status.includes("✅")) return green[600];
  if (status.includes("⚠️ No existe") || status.includes("⚠️ Error")) return red[700];
  if (status.includes("⚠️ Ya verificado")) return orange[500];
  return yellow[700];
};

const StatusMessage = ({ emailStatus }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      backgroundColor: getStatusColor(emailStatus),
      color: "common.white",
      padding: 2,
      height: "300px",
      borderRadius: "8px 8px 0 0",
    }}
  >
    {emailStatus.includes("✅") ? (
      <>
        <CheckCircleIcon sx={{ fontSize: 40, marginBottom: 1 }} />
        <Typography variant="h6" fontWeight="bold">
          {emailStatus}
        </Typography>
      </>
    ) : (
      <>
        <WarningIcon sx={{ fontSize: 40, marginBottom: 1 }} />
        <Typography variant="h6" fontWeight="bold">
          {emailStatus}
        </Typography>
      </>
    )}
  </Box>
);

const ActionButtons = ({ countdown }) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 2,
        marginTop: "30px",
        flexDirection: "column",
      }}
    >
      <Button variant="contained" color="primary" onClick={() => navigate("/")}>
        Ir al inicio
      </Button>
      {countdown > 0 && (
        <Typography variant="body2" color="textSecondary">
          Redirigiendo al login en {countdown} segundo{countdown !== 1 ? "s" : ""}...
        </Typography>
      )}
    </Box>
  );
};

const EmailVerification = () => {
  const [emailStatus, setEmailStatus] = useState("🟡 Verificando correo...");
  const [countdown, setCountdown] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const email = searchParams.get("email");
    const token = searchParams.get("token");

    if (email && token) {
      fetch(`${route}/userTokens/verify-email?mail=${email}&token_enviado=${token}`)
        .then((res) => res.json())
        .then((data) => {
          switch (data.codigo) {
            case 200:
              setEmailStatus("✅ ¡Correo verificado con éxito!");
              setCountdown(5);
              break;
            case 404:
              setEmailStatus("⚠️ Token vencido o correo electrónico inexistente");
              break;
            case 409:
              setEmailStatus("⚠️ El usuario ya fue verificado");
              break;
            default:
              setEmailStatus("⚠️ Error desconocido al verificar");
          }
        })
        .catch((err) => {
          setEmailStatus("⚠️ Error al verificar el correo");
        });
    } else {
      setEmailStatus("⚠️ Faltan parámetros de verificación");
    }
  }, []);

  useEffect(() => {
    let interval;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prev) => prev - 1);
      }, 1000);
    } else if (countdown === 0) {
      navigate("/login");
    }
    return () => clearInterval(interval);
  }, [countdown, navigate]);

  return (
    <Card
      sx={{
        margin: "auto",
        padding: 1,
        borderRadius: 2,
        boxShadow: 0,
        width: "100%",
      }}
    >
      <StatusMessage emailStatus={emailStatus} />
      <CardActions
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "common.white",
          border: "1px solid rgba(0, 0, 0, 0.12)",
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          padding: 2,
          width: "40%",
          margin: "-50px auto",
          marginBottom: "20px",
          padding: "60px",
        }}
      >
        <ActionButtons countdown={countdown ?? 0} />
      </CardActions>
    </Card>
  );
};

export default EmailVerification;
